import { METHODS_BY_ID } from "../methods";
import type { MagiMethod } from "../config";

export function MethodSelector({
  value,
  onChange,
  disabled,
  allowedMethods,
}: {
  value: MagiMethod;
  onChange: (v: MagiMethod) => void;
  disabled?: boolean;
  allowedMethods: MagiMethod[];
}) {
  const spec = METHODS_BY_ID[value];
  return (
    <div className="stack">
      <div className="row" style={{ justifyContent: "space-between" }}>
        <span className="section-label">Decision method</span>
        <span className="muted" style={{ fontSize: 14 }}>
          {spec?.tagline}
        </span>
      </div>
      <div className="pill-row" role="tablist" aria-label="Decision method">
        {allowedMethods.map((id) => {
          const m = METHODS_BY_ID[id];
          if (!m) return null;
          return (
            <button
              key={m.id}
              className={`pill${value === m.id ? " active" : ""}`}
              onClick={() => onChange(m.id)}
              disabled={disabled}
              role="tab"
              aria-selected={value === m.id}
              data-testid={`method-${m.id}`}
            >
              <span aria-hidden style={{ opacity: 0.7 }}>{m.icon}</span> {m.label}
            </button>
          );
        })}
      </div>
      <div className="info-pop" role="note">
        <div>
          <h4>{spec?.label}</h4>
          <p>{spec?.description}</p>
        </div>
      </div>
    </div>
  );
}
